var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "RoundedButton",
    class: [{
      'RoundedButton--inactive': _vm.inactive
    }, 'RoundedButton--' + _vm.type, 'RoundedButton--' + _vm.size],
    attrs: {
      "aria-label": _vm.label,
      "disabled": _vm.inactive,
      "type": _vm.buttonType
    },
    on: {
      "click": _vm.buttonClicked,
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buttonClicked.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.buttonClicked.apply(null, arguments);
      }]
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }